// 时间车
import Vue from 'vue';
export default new Vue();
